import { LocaleLink as Link } from '@/components/LocaleLink'
import { useFooter } from '@/lib/cms/hooks'
import { useContactEmail } from '@/lib/useContactEmail'
import { useTranslation } from '@/lib/i18n/LocaleContext'
import { SITE_NAME } from '@/site.config'

export function SiteFooter() {
  const { t } = useTranslation()
  const { data } = useFooter()
  const { email, mailto, onCtaClick, copied } = useContactEmail()
  // Rendered on the server AND in the browser: both evaluate this in the same
  // year except for a few seconds around New Year, so it cannot drift in SSR.
  const year = new Date().getFullYear()

  return (
    <footer className="footer">
      <div className="wrap footer-main">
        <div>
          <p className="footer-name">{SITE_NAME}</p>
          {data?.tagline && <p className="muted">{data.tagline}</p>}
        </div>
        {data?.links.length ? (
          <nav aria-label={t.nav.footer} className="footer-nav">
            {data.links.map((l) => (
              <Link key={l.href} to={l.href} className="nav-link">{l.label}</Link>
            ))}
          </nav>
        ) : null}
      </div>
      <div className="wrap footer-bottom">
        <p className="small muted">{t.footer.copyright(year)}</p>
        {email && (
          <span className="copy-anchor">
            <a href={mailto()} onClick={onCtaClick} className="nav-link small">{email}</a>
            {copied && <span className="copied-tooltip">{t.common.copied}</span>}
          </span>
        )}
      </div>
    </footer>
  )
}
